import clsx from 'clsx'

/**
 * Skeleton — loading placeholder. Use instead of spinner-only or blank
 * (`return null`) loading states. Uses the opacity `docLoadingPulse` keyframe
 * (defined in tailwind.css) rather than the project's scale-based `animate-pulse`,
 * so blocks shimmer without layout shift.
 */
const PULSE = { animation: 'docLoadingPulse 1.4s ease-in-out infinite' }

export function Skeleton({ className, style }) {
  return <div className={clsx('rounded-md bg-gray-200 dark:bg-white/10', className)} style={{ ...PULSE, ...style }} />
}

export function SkeletonText({ lines = 3, className }) {
  return (
    <div className={clsx('space-y-2', className)}>
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton key={i} className={clsx('h-4', i === lines - 1 ? 'w-2/3' : 'w-full')} />
      ))}
    </div>
  )
}

export function SkeletonCard({ className }) {
  return (
    <div className={clsx('rounded-2xl border border-gray-200 p-5 dark:border-white/10', className)}>
      <Skeleton className="mb-4 h-32 w-full" />
      <Skeleton className="mb-2 h-4 w-3/4" />
      <SkeletonText lines={2} />
    </div>
  )
}
